var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_288_768",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_288_768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3193 30.073L33.0077 19.4039L31.4269 17.8347L22.4308 26.8308L17.5731 21.9732L15.9116 23.6346L22.3193 30.073ZM24.5 42.9307C20.1539 41.7384 16.5674 39.1519 13.7405 35.1711C10.9135 31.1904 9.50005 26.7821 9.50005 21.9461V10.6616L24.5 5.04625L39.5 10.6616V21.9461C39.5 26.7821 38.0865 31.1904 35.2596 35.1711C32.4326 39.1519 28.8461 41.7384 24.5 42.9307ZM24.5 40.5615C28.2308 39.3461 31.2853 37.009 33.6635 33.55C36.0417 30.091 37.2308 26.2231 37.2308 21.9461V12.2423L24.5 7.4577L11.7693 12.2423V21.9461C11.7693 26.2231 12.9584 30.091 15.3366 33.55C17.7148 37.009 20.7692 39.3461 24.5 40.5615Z",
    fill: "#233DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUser);
export default __webpack_public_path__ + "static/media/verified_user.d90c80981f41fc2d39b7a6bec0724633.svg";
export { ForwardRef as ReactComponent };